/* eslint no-unused-vars: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './../../../styles/pane.css';

const Pane = ({ label, children, fluid, showErrorIcon, tabActive = 0, tabPosition }) => {

    return (
        <div className={classNames({ 'main-pane': true, 'active-pane': (tabActive === tabPosition)})}>
            {(tabActive === tabPosition) && children}
        </div>
    )
};

Pane.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    fluid: PropTypes.bool.isRequired,
    showErrorIcon: PropTypes.bool
};
Pane.defaultProps = {
    label: '',
    fluid: true,
    showErrorIcon: false
};

export default Pane;



// WEBPACK FOOTER //
// ./src/components/shared/tabs/pane.js